<template>
  <section class="container-fluid">
    <v-header />
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8 mx-auto">
          <h4>
            Un de vos amis vous a <span class="highlight highlight-green-300">parrainé </span>
          </h4>
          <div class="mb-3">
            Commençons par faire connaissance :)
          </div>
        </div>
        <div class="col-12 col-lg-8 mx-auto">
          <div class="row">
            <div class="col-6 mb-3">
              <v-input
                label="Prénom"
                path="firstName"
                placeholder="Jean"
                action-module="client"
              />
            </div>
            <div class="col-6 mb-3">
              <v-input
                label="Nom"
                path="lastName"
                placeholder="Dupont"
                action-module="client"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <v-input
                label="Adresse e-mail"
                path="email"
                placeholder="Jean@dupont.com"
                action-module="client"
                :validation="validateEmail"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8 mx-auto mt-3">
          <v-loader
            title="Continuer"
            :disabled="!isValid"
            icon="arrow-white-right"
            :next="sendSponsorship"
            class="w-100"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import { validateEmail } from '@/utils/validators';

import { Input } from '@/components/common/input';
import Header from '@/components/common/layout/Header.vue';

export default {
  name: 'SponsorshipLanding',
  components: {
    'v-input': Input,
    'v-header': Header,
  },
  data() {
    return {
      validateEmail,
    };
  },
  computed: {
    sponsorId() {
      if (this.$route.query) {
        return this.$route.query.id;
      }
      return false;
    },
    client() {
      return this.$store.getters['client/get'];
    },
    isValid() {
      return this.validateEmail(this.client.email)
        && this.sponsorId
        && this.client.firstName !== ''
        && this.client.lastName !== '';
    },
  },
  methods: {
    async sendSponsorship() {
      await this.$store.dispatch('sponsorship/addSoloReferral', this.sponsorId);
      window.location.assign(`${import.meta.env.VITE_WIDGET_URL}`);
    },
  },
};
</script>
